import React from 'react';
import './Filters.css';

function DatePickerComponent({ selectedDate, setSelectedDate, maxDate }) {
  return (
    <input 
      className="custom-date-picker" 
      type="date" 
      value={selectedDate ? selectedDate.toISOString().split('T')[0] : ''} 
      onChange={(e) => {
        const date = e.target.value ? new Date(e.target.value) : null; 
        setSelectedDate(date); 
      }} 
      max={maxDate ? maxDate.toISOString().split('T')[0] : undefined}
    />
  );
}

export default DatePickerComponent; 